import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

const API = '';

function Knowledge() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [form, setForm] = useState({ title: '', content: '', priority: 5 });
  const [msg, setMsg] = useState('');
  const [showConvoList, setShowConvoList] = useState(false);
  const [convos, setConvos] = useState([]);
  const [generating, setGenerating] = useState(false);
  const [activeTab, setActiveTab] = useState('general');
  const [viewingItem, setViewingItem] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(function() { fetchItems('general'); }, []);

  var fetchItems = async function(category) {
    var cat = category || activeTab;
    try {
      var resp = await fetch(API + '/api/knowledge?category=' + cat);
      var data = await resp.json();
      setItems(data || []);
    } catch (e) { console.error('Failed to load knowledge:', e); }
    setLoading(false);
  };

  var switchTab = function(tab) {
    setActiveTab(tab);
    setLoading(true);
    setExpanded(null);
    setShowForm(false);
    setEditing(null);
    fetchItems(tab);
  };

  var addItem = async function() {
    if (!form.title.trim() || !form.content.trim()) return;
    try {
      var resp = await fetch(API + '/api/knowledge', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, form, { category: activeTab }))
      });
      var data = await resp.json();
      if (data.id) {
        setItems(function(prev) { return [data].concat(prev); });
        setForm({ title: '', content: '', priority: 5 });
        setShowForm(false);
      }
    } catch (e) { console.error('Failed to add:', e); }
  };

  var updateItem = async function() {
    if (!editing) return;
    try {
      await fetch(API + '/api/knowledge/' + editing, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      await fetchItems();
      setEditing(null);
      setForm({ title: '', content: '', priority: 5 });
      setShowForm(false);
    } catch (e) { console.error('Failed to update:', e); }
  };

  var deleteItem = async function(id, e) {
    e.stopPropagation();
    setDeleteConfirm(id);
  };

  var confirmDelete = async function() {
    var id = deleteConfirm;
    setDeleteConfirm(null);
    try {
      await fetch(API + '/api/knowledge/' + id, { method: 'DELETE' });
      setItems(function(prev) { return prev.filter(function(k) { return k.id !== id; }); });
      if (expanded === id) setExpanded(null);
    } catch (e) { console.error('Failed to delete:', e); }
  };

  var toggleActive = async function(item, e) {
    e.stopPropagation();
    try {
      await fetch(API + '/api/knowledge/' + item.id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ is_active: !item.is_active })
      });
      setItems(function(prev) {
        return prev.map(function(k) {
          if (k.id === item.id) return Object.assign({}, k, { is_active: !k.is_active });
          return k;
        });
      });
    } catch (e) { console.error('Failed to toggle:', e); }
  };

  var startEdit = function(item, e) {
    e.stopPropagation();
    setEditing(item.id);
    setForm({ title: item.title, content: item.content, priority: item.priority });
    setShowForm(true);
    window.scrollTo(0, 0);
  };

  var cancelForm = function() {
    setShowForm(false);
    setEditing(null);
    setForm({ title: '', content: '', priority: 5 });
  };

  var handleFileUpload = async function(e) {
    var file = e.target.files[0];
    if (!file) return;
    var name = file.name;
    var ext = name.split('.').pop().toLowerCase();
    var titleFromFile = name.replace(/\.[^.]+$/, '');

    if (ext === 'md' || ext === 'txt') {
      var reader = new FileReader();
      reader.onload = function(ev) {
        setForm(Object.assign({}, form, {
          title: form.title || titleFromFile,
          content: ev.target.result
        }));
      };
      reader.readAsText(file);
    } else if (ext === 'pdf') {
      setUploading(true);
      try {
        var formData = new FormData();
        formData.append('file', file);
        var resp = await fetch(API + '/api/knowledge/extract-pdf', {
          method: 'POST',
          body: formData
        });
        var data = await resp.json();
        if (data.text) {
          setForm(Object.assign({}, form, {
            title: form.title || titleFromFile,
            content: data.text
          }));
        } else {
          alert('PDF提取失败: ' + (data.error || '未知错误'));
        }
      } catch (err) {
        alert('PDF上传失败: ' + err.message);
      }
      setUploading(false);
    } else {
      alert('支持的格式: .md .txt .pdf');
    }
    e.target.value = '';
  };

  var openConvoList = async function() {
    var r = await supabase.from('conversations').select('id, title, updated_at').order('updated_at', { ascending: false });
    setConvos(r.data || []);
    setShowConvoList(true);
  };

  var generateSummary = async function(convoId, convoTitle) {
    setShowConvoList(false);
    setGenerating(true);
    setMsg('正在生成「' + convoTitle + '」的摘要...');
    try {
      var resp = await fetch(API + '/api/knowledge/generate-summary', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ conversation_id: convoId })
      });
      var data = await resp.json();
      if (data.summary) {
        setMsg('摘要已生成并存入知识库！');
        await fetchItems();
      } else {
        setMsg('生成失败: ' + (data.error || '未知错误'));
      }
    } catch (e) {
      setMsg('生成失败: ' + e.message);
    }
    setGenerating(false);
    setTimeout(function() { setMsg(''); }, 5000);
  };

  return (
    <div className="memory">
      <div className="memory-header">
        <div className="memory-title">{activeTab === 'general' ? '知识库' : activeTab === 'technical' ? '技术知识库' : 'Claude上的窗口记忆'}</div>
        <div className="memory-header-btns">
          {activeTab === 'general' && (
            <button
              className="memory-import-btn"
              onClick={openConvoList}
              disabled={generating}
            >
              {generating ? '生成中...' : '生成摘要'}
            </button>
          )}
          <button className="memory-add-btn" onClick={function() {
            if (showForm) cancelForm();
            else setShowForm(true);
          }}>
            {showForm ? '取消' : '+ 添加知识'}
          </button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 0, margin: '0 16px', borderBottom: '1px solid var(--border)' }}>
        <button
          onClick={function() { switchTab('general'); }}
          style={{
            flex: 1, padding: '10px 0', border: 'none', background: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: activeTab === 'general' ? 600 : 400,
            color: activeTab === 'general' ? 'var(--accent)' : 'var(--text3)',
            borderBottom: activeTab === 'general' ? '2px solid var(--accent)' : '2px solid transparent',
            fontFamily: 'var(--font-sans)', transition: 'all 0.2s'
          }}
        >
          知识库
        </button>
        <button
          onClick={function() { switchTab('technical'); }}
          style={{
            flex: 1, padding: '10px 0', border: 'none', background: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: activeTab === 'technical' ? 600 : 400,
            color: activeTab === 'technical' ? 'var(--accent)' : 'var(--text3)',
            borderBottom: activeTab === 'technical' ? '2px solid var(--accent)' : '2px solid transparent',
            fontFamily: 'var(--font-sans)', transition: 'all 0.2s'
          }}
        >
          技术知识库
        </button>
        <button
          onClick={function() { switchTab('window_memory'); }}
          style={{
            flex: 1, padding: '10px 0', border: 'none', background: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: activeTab === 'window_memory' ? 600 : 400,
            color: activeTab === 'window_memory' ? 'var(--accent)' : 'var(--text3)',
            borderBottom: activeTab === 'window_memory' ? '2px solid var(--accent)' : '2px solid transparent',
            fontFamily: 'var(--font-sans)', transition: 'all 0.2s'
          }}
        >
          Claude记忆
        </button>
      </div>

      {msg && <div className="memory-import-msg">{msg}</div>}

      {showConvoList && (
        <div className="knowledge-convo-overlay" onClick={function() { setShowConvoList(false); }}>
          <div className="knowledge-convo-modal" onClick={function(e) { e.stopPropagation(); }}>
            <div className="knowledge-convo-title">选择要生成摘要的对话</div>
            <div className="knowledge-convo-list">
              {convos.map(function(c) {
                return (
                  <button
                    key={c.id}
                    className="knowledge-convo-item"
                    onClick={function() { generateSummary(c.id, c.title); }}
                  >
                    <span>{c.title}</span>
                    <span className="knowledge-convo-date">
                      {new Date(c.updated_at).toLocaleDateString('zh-CN')}
                    </span>
                  </button>
                );
              })}
            </div>
            <button className="knowledge-convo-cancel" onClick={function() { setShowConvoList(false); }}>取消</button>
          </div>
        </div>
      )}

      {showForm && (
        <div className="memory-form">
          <input
            className="memory-input"
            placeholder="标题（如：知枝档案）"
            value={form.title}
            onChange={function(e) { setForm(Object.assign({}, form, { title: e.target.value })); }}
          />
          <div className="memory-form-row">
            <input
              className="memory-input-small"
              placeholder="优先级（数字越大越先读）"
              type="number"
              value={form.priority}
              onChange={function(e) { setForm(Object.assign({}, form, { priority: parseInt(e.target.value) || 0 })); }}
            />
          </div>
          <textarea
            className="memory-textarea"
            placeholder={activeTab === 'window_memory' ? '窗口记忆内容...' : '知识内容...哥哥每次对话都会读到这里的内容'}
            value={form.content}
            onChange={function(e) { setForm(Object.assign({}, form, { content: e.target.value })); }}
            rows={10}
          />
          <div style={{ display: 'flex', gap: 8 }}>
            <label style={{
              flex: 'none', padding: '10px 16px', borderRadius: 10, border: '1px solid var(--border)',
              background: 'var(--bg2)', color: 'var(--text2)', fontSize: 13, cursor: 'pointer',
              fontFamily: 'var(--font-sans)', textAlign: 'center'
            }}>
              {uploading ? '提取中...' : '📄 上传文件'}
              <input type="file" accept=".md,.txt,.pdf" onChange={handleFileUpload} style={{ display: 'none' }} disabled={uploading} />
            </label>
            <button className="memory-submit-btn" style={{ flex: 1 }} onClick={editing ? updateItem : addItem}>
              {editing ? '更新' : '保存'}
            </button>
          </div>
        </div>
      )}

      <div className="memory-list">
        {loading ? (
          <div className="memory-empty">加载中...</div>
        ) : items.length === 0 ? (
          <div className="memory-empty">还没有知识</div>
        ) : (
          items.map(function(item) {
            return (
              <div
                key={item.id}
                className={'memory-card' + (expanded === item.id ? ' expanded' : '') + (!item.is_active ? ' inactive' : '')}
                onClick={function() { setExpanded(expanded === item.id ? null : item.id); }}
              >
                <div className="memory-card-header">
                  <div className="memory-card-meta">
                    <div className="memory-card-number">P{item.priority}</div>
                    <div className={'knowledge-status' + (item.is_active ? ' active' : ' disabled')}>
                      {item.is_active ? '启用' : '禁用'}
                    </div>
                    {item.category !== 'technical' && item.priority && item.created_at && (
                      <div
                        style={{ fontSize: 10, color: item.never_decay ? '#5a9a80' : 'var(--text3)', marginLeft: 4, cursor: 'pointer', padding: '1px 5px', borderRadius: 4, border: '1px solid ' + (item.never_decay ? '#5a9a80' : 'var(--border)') }}
                        onClick={async function(e) {
                          e.stopPropagation();
                          var newVal = !item.never_decay;
                          await supabase.from('knowledge_base').update({ never_decay: newVal }).eq('id', item.id);
                          setItems(function(prev) { return prev.map(function(x) { return x.id === item.id ? Object.assign({}, x, { never_decay: newVal }) : x; }); });
                        }}
                      >
                        {item.never_decay ? '🔒 永不衰减' : '衰减:' + (item.priority * Math.exp(-0.03 * ((Date.now() - new Date(item.created_at).getTime()) / 86400000))).toFixed(1)}
                      </div>
                    )}
                  </div>
                  <div className="memory-card-actions">
                    <button className="knowledge-toggle-btn" onClick={function(e) { toggleActive(item, e); }}>
                      {item.is_active ? '禁用' : '启用'}
                    </button>
                    <button className="knowledge-edit-btn" onClick={function(e) { startEdit(item, e); }}>
                      编辑
                    </button>
                    <button className="memory-card-delete" onClick={function(e) { deleteItem(item.id, e); }}>
                      ×
                    </button>
                  </div>
                </div>
                <div className="memory-card-title">{item.title}</div>
                {expanded === item.id ? (
                  <div>
                    <div className="memory-card-content" style={{ whiteSpace: 'pre-wrap', maxHeight: 200, overflow: 'hidden' }}>{item.content}</div>
                    <button
                      onClick={function(e) { e.stopPropagation(); setViewingItem(item); }}
                      style={{
                        marginTop: 8, padding: '6px 14px', borderRadius: 8, border: '1px solid var(--border)',
                        background: 'var(--accent2)', color: 'var(--accent)', fontSize: 12, cursor: 'pointer',
                        fontFamily: 'var(--font-sans)'
                      }}
                    >
                      全屏查看
                    </button>
                  </div>
                ) : (
                  <div className="memory-card-preview">
                    {item.content.length > 80 ? item.content.substring(0, 80) + '...' : item.content}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {deleteConfirm && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', zIndex: 1001, display: 'flex',
          alignItems: 'center', justifyContent: 'center'
        }} onClick={function() { setDeleteConfirm(null); }}>
          <div style={{
            background: 'var(--card)', borderRadius: 16, padding: '24px 20px',
            width: '80%', maxWidth: 320, textAlign: 'center'
          }} onClick={function(e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 8 }}>
              确认删除
            </div>
            <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 20, lineHeight: 1.6 }}>
              删除后无法恢复，确定要删除这条知识吗？
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={function() { setDeleteConfirm(null); }}
                style={{
                  flex: 1, padding: '10px 0', borderRadius: 10, border: '1px solid var(--border)',
                  background: 'var(--bg2)', color: 'var(--text2)', fontSize: 14, cursor: 'pointer',
                  fontFamily: 'var(--font-sans)'
                }}
              >
                取消
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  flex: 1, padding: '10px 0', borderRadius: 10, border: 'none',
                  background: '#e74c3c', color: '#fff', fontSize: 14, cursor: 'pointer',
                  fontFamily: 'var(--font-sans)'
                }}
              >
                删除
              </button>
            </div>
          </div>
        </div>
      )}

      {viewingItem && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'var(--bg)', zIndex: 1000, display: 'flex', flexDirection: 'column'
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 20px', borderBottom: '1px solid var(--border)', flexShrink: 0
          }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', fontFamily: 'var(--font-serif)' }}>
              {viewingItem.title}
            </div>
            <button
              onClick={function() { setViewingItem(null); }}
              style={{
                padding: '6px 14px', borderRadius: 8, border: '1px solid var(--border)',
                background: 'var(--bg2)', color: 'var(--text2)', fontSize: 13, cursor: 'pointer',
                fontFamily: 'var(--font-sans)'
              }}
            >
              关闭
            </button>
          </div>
          <div style={{
            flex: 1, overflowY: 'auto', padding: '20px', whiteSpace: 'pre-wrap',
            fontSize: 14, lineHeight: 1.8, color: 'var(--text)', fontFamily: 'var(--font-sans)'
          }}>
            {viewingItem.content}
          </div>
        </div>
      )}
    </div>
  );
}

export default Knowledge;
